import React, { createContext, useReducer, useEffect } from "react";

import authReducer from "./authReducer";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();

export default function AuthContextProvider(props) {
  const [admin_panel_user, dispatch] = useReducer(authReducer, {}, () => {
    const localData = localStorage.getItem("admin_panel_user");
    return localData ? JSON.parse(localData) : {};
  });

  const login = async (data) => {
    dispatch({
      type: "LOGIN",
      payload: data,
    });
  };

  const logout = () => {
    
    dispatch({
      type: "LOGOUT",
      payload: {},
    });
  };

  useEffect(() => {
    localStorage.setItem("admin_panel_user", JSON.stringify(admin_panel_user));
  }, [login]);

  return (
    <AuthContext.Provider value={{ login, admin_panel_user, logout }}>
      {props.children}
    </AuthContext.Provider>
  );
}
